import React, { useState } from 'react';
import { Form, Button, Input, Row, Switch, DatePicker, Space } from 'antd';
import Dropdown from 'components/Dropdown'
import InputTag from 'components/InputTag';
import { useTheme } from 'contexts/theme';

const { Item } = Form;

export default function RegionForm({
  layout = 'horizontal',
  onSave,
  formFields
}: {
  layout?: 'vertical' | 'inline' | 'horizontal';
  onSave: any;
  formFields: any;
}) {
  const [save] = onSave();
  const { dark } = useTheme();
  const [form] = Form.useForm();
  let initValue ;
  let secondValue;

  function handleSave(values: any) {
    save(values);
    form.resetFields();
  }

  function handleChange(name: string, value: any) {
    form.setFieldsValue({ [name]: value });
  }

  const handleMultiChange = (field, value, index) => {
    if (index === 1) {
      initValue = value
    } else if (index === 2) {
      secondValue = value
    }
    const combinedValues = `${initValue } ${secondValue}`;
    form.setFieldsValue({ [field]: combinedValues });
  };

  function renderSwitch(name: string, status: string) {
    form.setFieldsValue({ [name]: status });
    let isChecked, onChange;
    if (typeof status === 'boolean') {
      isChecked = status;
      onChange = (checked: boolean) => handleChange(name, checked);
    } else {
      isChecked = status === 'active';
      onChange = (checked: boolean) =>
        handleChange(name, checked ? 'active' : 'inactive');
    }
    return <Switch defaultChecked={isChecked} onChange={onChange} />;
  }

  return (
    <Form
      form={form}
      name="table-form"
      layout={layout}
      className={dark ? 'form-dark' : 'form-light'}
      onFinish={handleSave}
    >
      <Row justify="space-between">
        {formFields &&
          formFields.map((field: any) => (
            <Item name={field.name} label={field.label} key={field.name} style={{ width: `${field.width && field.width}px`, }}>
              {field.dataSource && field.mulitiField !== true ? (
                <Dropdown
                  dataSource={field.dataSource}
                  placeholder={field.label}
                  valueKey={field.valueKey}
                  mode={field.mode && field.mode}
                  allOptionName={field.allOptionName}
                  showSearch={field?.showSearch}
                />
              ) : field.mode == "inputTag" ? (
                <InputTag
                  dataSource={[]}
                  placeholder={field.label}
                  valueKey={field.valueKey}
                  allOptionName={field.allOptionName}
                />
              ) : field.status != undefined ? (
                renderSwitch(field.name, field.status)
              ) : field.date == true ? (
                <DatePicker />
              ) : field?.mulitiField == true ? (

                <Space>
                  <Dropdown
                    onChange={(value) => handleMultiChange(field.subname, value, 1)}
                    dataSource={field.subSource}
                    valueKey={field.subname}
                    placeholder={"Rate"}
                    allOptionName={field.allOptionName}
                    showSearch={field?.showSearch}
                  />
                  <Dropdown
                    onChange={(value) => handleMultiChange(field.name, value, 2)}
                    dataSource={field.dataSource}
                    placeholder={field.label}
                    valueKey={field.valueKey}
                    mode={field.mode && field.mode}
                    allOptionName={field.allOptionName}
                    showSearch={field?.showSearch}
                  />
                </Space>
              ) : (
                <Input placeholder={field.label} type="text" />
              )}
            </Item>
          ))}
        <Item>
          <Button type="primary" htmlType="submit">
            Add
          </Button>
        </Item>
      </Row>
    </Form>
  );
}
